import axios from 'axios';

import { request } from '../../helpers/requests';

const WorkflowMarketplaceService = {
  getWorkflows: () => request({
    call: axios.get('/workflowMarketplace/workflows'),
    errMsg: 'Could not get workflow marketplace workflows',
    hideSuccessToast: true,
  }),
  getWorkflowImages: (name) => request({
    call: axios.get(`/workflowMarketplace/workflows/${encodeURIComponent(name)}`),
    errMsg: 'Could not get workflow images',
    hideSuccessToast: true,
  }),
  importWorkflow: ({ id, name, divisions }) => request({
    call: axios.post('/workflowMarketplace/import', { id, name, divisions }),
    errMsg: 'Could not import workflow',
    successMsg: 'Workflow imported successfully',
  }),
};

export default WorkflowMarketplaceService;
